import { UserRole } from "tm-shared/types";

export interface KpiProgressCapabilities {
    canUseManagerKpiRequests: boolean;
}

export const getKpiProgressCapabilities = (
    role: UserRole,
): KpiProgressCapabilities => ({
    canUseManagerKpiRequests: role === UserRole.Sv,
});
